export default function snippet(text, length) {
  if (text && text.toString().length > (length || 20)) {
    return text.toString().substring(0, length || 20) + '...'
  } else if (!text) {
    return ''
  } else {
    return text
  }
}
